import moment from "moment";

export const getRequestTypeLabel = (requestType) => {
  switch (requestType) {
    case 1: return "New batch request";
    case 3:
    case 4: return "New class request";
    case 5: return "Class substitution request";
    default: return "Batch change request";
  }
};

export const isClassRequest = (rt) => rt === 3 || rt === 4 || rt === 5;

export const formatSchedule = (timings) => {
  if (!timings || timings.length === 0) return "-";
  const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  const schedule = [];
  timings.forEach((row) => {
    days.forEach((day) => {
      const from = row[day]?.from;
      if (from) {
        schedule.push(
          `${day.charAt(0).toUpperCase() + day.slice(1)} (${moment(from, "HH:mm").format("hh:mm A")})`
        );
      }
    });
  });
  return schedule.join(", ") || "-";
};

export const formatTzTime = (dateStr, tzCode) => {
  if (!dateStr) return "-";
  const formatted = moment(dateStr).format("DD-MM-YYYY, hh:mm A");
  return tzCode ? `${formatted} (${tzCode})` : formatted;
};

export const formatStartDate = (dateStr) => {
  if (!dateStr) return "-";
  return moment(dateStr).format("DD-MM-YYYY");
};

export const formatCountdown = (validTill) => {
  if (!validTill) return null;
  const diff = new Date(validTill).getTime() - Date.now();
  if (diff <= 0) return null;
  const totalSecs = Math.floor(diff / 1000);
  const days = Math.floor(totalSecs / 86400);
  const hours = Math.floor((totalSecs % 86400) / 3600);
  const mins = Math.floor((totalSecs % 3600) / 60);
  const secs = totalSecs % 60;
  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0 || days > 0) parts.push(`${hours}h`);
  parts.push(`${mins}m`);
  if (days === 0) parts.push(`${String(secs).padStart(2, "0")}s`);
  return `Expires in ${parts.join(" ")}`;
};
